import request from '@/utils/request';
import { getLocalToken } from '@/utils/token';
const { VUE_APP_LAOSHIBANG } = process.env;

export function getMyAppList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aitalk/mylist',
    method: 'post',
    data: { ...params }
  });
}

export function sendQuestion(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/question',
    method: 'post',
    data: { ...params },
    responseType: 'stream'
  });
}

export function getWsToken(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/ws/token/get',
    method: 'post',
    data: { ...params }
  });
}

export function getAppLogList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aitalk/log/list',
    method: 'post',
    data: { ...params }
  });
}

export function getTalkInfo(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aitalk/info',
    method: 'post',
    data: { ...params }
  });
}

// 获取年部学科
export function getGradeSubject(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/base/resource/config',
    method: 'post',
    data: { ...params }
  });
}

// 获取教材版本
export function getTextbookVersion(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/jyy/config/tabList',
    method: 'post',
    data: { ...params }
  });
}

// 获取年级
export function getGradeOptions() {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/base/grade/config',
    method: 'get',
  });
}

// 获取Paper信息
export function getPaperInfo(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/paper/info',
    method: 'post',
    data: { ...params }
  });
}

// 获取课件信息
export function getCoursewareInfo(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/courseware/info',
    method: 'post',
    data: { ...params }
  });
}

// 根据新课件ID查询复制状态
export function getCoursewareCopyStatus(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/courseware/copy/stat',
    method: 'post',
    data: { ...params }
  });
}

// 通过paperID获取下载链接
export function getPaperDownloadUrl(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/paper/file',
    method: 'post',
    data: { ...params }
  });
}

// 获取课件下载链接
export function getCoursewareDownloadUrl(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/courseware/file',
    method: 'post',
    data: { ...params }
  });
}

// 将普通对话导出成word
export function exportToWord(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/file',
    method: 'post',
    data: { ...params },
    responseType: 'blob'
  });
}

// 将智能组卷对话导出成word
export function exportToQuestionWord(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/paper/word',
    method: 'post',
    data: { ...params }
  });
}

export function UploadToken(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/oss/token/get',
    method: 'GET',
    data: { ...params }
  });
}

export function delMyAppList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aitalk/mylist/del',
    method: 'POST',
    data: { ...params }
  });
}

export function getKnowseach(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/knowledge/search',
    method: 'POST',
    data: { ...params }
  });
}

export function getMiniProSeach(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/jyy/miniprogram/keyword',
    method: 'POST',
    data: { ...params }
  });
}

// 获取问题ai
export function getQuestionai(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/paper/question',
    method: 'POST',
    data: { ...params }
  });
}

export function getanswer(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/question/infos',
    method: 'POST',
    data: { ...params }
  });
}

// 获取年级学科
export function getgrade(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/knowledge/config',
    method: 'POST',
    data: { ...params }
  });
}

// 获取年级学科 小程序插件专用
export function getminiProGrade(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/base/resource/config?source=miniprogram',
    method: 'POST',
    data: { ...params }
  });
}

// 获取nb插件详情
export function nbBookDetall(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/jyy/nobook/index',
    method: 'POST',
    data: { ...params }
  });
}

// 小程序生成内容
export function getMiniProGramAi(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/jyy/miniprogram/detail',
    method: 'POST',
    data: { ...params }
  });
}

// 导出智能组卷
export function exportPaper(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/paper/word',
    method: 'POST',
    data: { ...params }
  });
}

/**
 * 获取PPT数据列表
 * @param {Object} params
 * @param {string} params.content - 内容
 * @returns {Promise}
 */
export function getPptDataList(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/file/template',
    method: 'post',
    data: params
  });
}

export function memeberProducts(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/member/products',
    method: 'GET',
    data: { ...params }
  });
}
export function memberOrderCreate(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/member/order/create',
    method: 'POST',
    data: { ...params }
  });
}

export function orderStatus(params) {
  const { orderId } = params;
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/member/order/status?orderId=' + orderId,
    method: 'GET',
    data: { ...params }
  });
}

export function orderList(params) {
  const { next, pageSize } = params;
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/member/order/list?next=' + next + '&pageSize=' + pageSize,
    method: 'GET'
  });
}

export function redeemUse(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/redeem/use',
    method: 'post',
    data: { ...params }
  });
}

export function orderPageList(params) {
  const { page, pageSize } = params;
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/member/order/pagelist?page=' + page + '&pageSize=' + pageSize,
    method: 'GET'
  });
}

// 语音识别
export function sendAsr(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + "/v1/aitalk/audio/async",
    method: "POST",
    data,
  });
}

// 获取语音识别结果
export function getAsrResult(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + "/v1/aitalk/audio/text",
    method: "GET",
    params,
  })
}

// 语音识别列表
export function getAsrList(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + "/v1/aitalk/audio/list",
    method: "POST",
    data,
  })
}
export function getHalfScreenUrl(params) {
    return request({
      url: VUE_APP_LAOSHIBANG + `/v2/aitalk/halfscreen/info`,
      method: 'post',
      data: { ...params },
    });
  }

  /* 获取ID资源详情
  请求参数:
  {
      "list":["1_0_4bf24447611b4c6eaf4fa6caecc2c87b"]
  }
  */
export function getResourceDetails(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + `/v2/agent/resource/details`,
    method: 'post',
    data: { ...params },
  });
}

// 将mcp对话导出成word
export function exportMcp(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/content/file',
    method: 'post',
    data: { ...params },
    responseType: 'blob'
  });
}

// 更新AitalkLog
export function updateAitalkLog(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aitalk/log/update',
    method: 'post',
    data: { ...params }
  });
}

/**
 * 使用 @microsoft/fetch-event-source 实现流式消息的 POST 请求
 * @param {Object} params 请求参数
 * @param {Function} onMessage 接收消息的回调函数
 * @param {Function} onError 错误处理的回调函数
 * @param {Function} onComplete 完成时的回调函数
 * @returns {Object} 包含关闭连接方法的对象
 */
export async function sendQuestionStream(url, params, onMessage, onError, onComplete) {
  // 创建一个控制器对象，无论后续操作成功与否都能返回
  const controller = new AbortController();
  let eventSource = null; // 存储fetchEventSource的引用
  let isClosed = false; // 标记连接是否已经关闭

  // 准备一个控制对象，稍后会返回给调用方，确保即使模块加载失败也能提供close方法
  const streamController = {
    close: () => {
      if (isClosed) {
        console.log('流式连接已经关闭，不需要再次关闭');
        return;
      }

      console.log('手动关闭流式连接');
      isClosed = true; // 标记为已关闭

      try {
        // 中断请求
        controller.abort();

        // 如果eventSource存在并有清理方法，则执行清理
        if (eventSource && typeof eventSource.close === 'function') {
          eventSource.close();
        }

        // 通知调用者连接已关闭
        if (onError && !streamController.isActive) {
          onError(new Error('连接已手动关闭'));
        }
      } catch (e) {
        console.error('关闭流式连接出错:', e);
      }

      // 确保状态更新
      streamController.isActive = false;
    },
    isActive: true
  };

  // 异步加载模块并设置流式请求
  try {
    // 如果已手动关闭则不继续
    if (isClosed) {
      console.log('连接已手动关闭，不会发起请求');
      return streamController;
    }

    const { fetchEventSource } = await import('@microsoft/fetch-event-source');

    // 准备鉴权信息
    const headers = {
      'Content-Type': 'application/json',
      'X-Client-Id': '1031102',
      'X-Device-Id': getLocalToken('TALDeviceId'),
      'X-Version-Num': '1',
      'X-Client-Token': getLocalToken('tal_token'),
      'Accept': 'text/event-stream' // 明确指定接受事件流
    };

    console.log('开始流式请求, 请求url:', url, '参数:', JSON.stringify(params));

    // 检查请求是否已经被中断
    if (controller.signal.aborted) {
      console.log('请求已被中断，不会发起网络请求');
      streamController.isActive = false;
      return streamController;
    }

    // 执行请求
    eventSource = fetchEventSource(`${VUE_APP_LAOSHIBANG}${url}`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(params),
      signal: controller.signal,
      openWhenHidden: true, // 在页面隐藏时保持连接

      onopen(response) {
        // 检查是否已关闭
        if (isClosed) {
          throw new Error('连接已手动关闭');
        }

        console.log('流式连接已打开, 状态:', response.status);
        if (response.ok) {
          console.log('连接成功建立');
          return; // 只有状态码为2xx时才继续
        }
        // 连接打开但状态码不为2xx, 抛出错误
        throw new Error(`服务器返回了错误状态码: ${response.status}`);
      },

      onmessage(event) {
        // 检查是否已关闭
        if (isClosed) {
          console.log('连接已关闭，忽略消息');
          return;
        }

        try {
          // 检查消息是否是有效的JSON格式
          if (typeof event.data === 'string' && event.data.trim().startsWith('{')) {
            const data = JSON.parse(event.data);

            // 处理不同类型的事件
            if (data.event === 'keep-alive') {
              // 保持连接活跃的消息，传递给回调函数
              if (onMessage && !isClosed) {
                onMessage(data);
              }
            } else if (data.event === 'ai-reply') {
              // AI回复消息，传递给回调函数
              if (onMessage && !isClosed) {
                // 标记当前是否为完整响应，方便客户端判断是否需要重新拼接
                if (data.data && data.data.status === 3) {
                  if (data.data.answerContent) {
                    // 如果是完整响应，设置一个标记
                    data.isComplete = true;
                  }
                }
                onMessage(data);
              }

              // 检查是否标记为完成
              if (data.data && data.data.status === 3) {
                console.log('流式传输完成 (done=true)');
                if (onComplete && !isClosed) {
                  onComplete();
                }
                // 更新控制器状态
                streamController.isActive = false;
              }
            } else {
              // 处理常规消息或没有event字段的消息
              if (onMessage && !isClosed) {
                // 标记当前是否为完整响应，方便客户端判断是否需要重新拼接
                if (data.data && data.data.status === 3) {
                  if (data.answerContent) {
                    // 如果是完整响应，设置一个标记
                    data.isComplete = true;
                  }
                }
                onMessage(data);
              }

              // 如果服务器返回了done标志，表示流已完成
              if (data.data && data.data.status === 3) {
                console.log('流式传输完成 (done=true)');
                if (onComplete && !isClosed) {
                  onComplete();
                }
                // 更新控制器状态
                streamController.isActive = false;
              }
            }
          } else {
            // 接收到非JSON格式的消息（如[tea-sdk]ready），直接忽略
            console.log('收到非JSON格式消息，跳过处理:', event.data);
            // 不需要抛出错误，也不需要调用onError
          }
        } catch (error) {
          if (!isClosed) {
            console.error('消息解析错误:', error, '原始消息:', event.data);
            onError && onError(error);
          }
        }
      },

      onerror(error) {
        // 如果是由于手动关闭导致的错误，则忽略
        if (isClosed || controller.signal.aborted) {
          console.log('连接已手动关闭，忽略错误');
          return false;
        }

        console.error('流式请求错误:', error);
        onError && onError(error);
        // 更新控制器状态
        streamController.isActive = false;
        return false; // 不自动重试
      },

      onclose() {
        // 如果是由于手动关闭导致的，则忽略
        if (isClosed) {
          console.log('连接已手动关闭，忽略关闭事件');
          return;
        }

        console.log('流式连接已关闭');
        // 更新状态
        isClosed = true;
        streamController.isActive = false;

        // onComplete已在数据done时调用，此处不再重复调用
      }
    }).catch(error => {
      // 如果是由于手动关闭导致的错误，则忽略
      if (isClosed || controller.signal.aborted) {
        console.log('连接已手动关闭，忽略错误');
        return;
      }

      console.error('流式请求设置失败:', error);
      onError && onError(error);
      // 更新控制器状态
      streamController.isActive = false;
    });
  } catch (error) {
    // 如果是由于手动关闭导致的错误，则忽略
    if (isClosed || controller.signal.aborted) {
      console.log('连接已手动关闭，忽略错误');
      return streamController;
    }

    console.error('模块加载或连接错误:', error);
    onError && onError(error);
    // 更新控制器状态
    streamController.isActive = false;
  }

  // 无论如何，始终同步返回控制器对象
  return streamController;
}

// 使用示例：
/**
 * 使用示例：
 *
 * // 发送问题，获取流式响应
 * const stream = sendQuestionStream(
 *   { content: '请问如何教授牛顿第一定律？', appId: 'xxx' },
 *   // 处理每条消息
 *   (data) => {
 *     console.log('收到消息:', data);
 *     // 在UI中追加显示消息内容
 *     this.responseText += data.content;
 *   },
 *   // 处理错误
 *   (error) => {
 *     console.error('发生错误:', error);
 *     this.$message.error('连接出错，请重试');
 *   },
 *   // 处理完成
 *   () => {
 *     console.log('流式消息接收完成');
 *     this.loading = false;
 *   }
 * );
 *
 * // 如需手动关闭连接
 * // stream.close();
 */

// 提交批改
export function submitCorrection(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/essay/revise/task/submit',
    method: 'post',
    data
  });
}

// 批改列表
export function getCorrectionList(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/essay/revise/task/list',
    method: 'post',
    data
  });
}

// 批改进度
export function getCorrectionProgress(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/essay/revise/task/status',
    method: 'post',
    data
  });
}

// 获取批改结果
export function getCorrectionResult(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/essay/revise/task/result',
    method: 'post',
    data
  });
}

// 供pptist 获取ppt数据
export function getPptData(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/ppt/get',
    method: 'post',
    data: params
  });
}

// 供pptist 保存ppt数据
export function savePptData(params) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v2/aitalk/ppt/save',
    method: 'post',
    data: params
  });
}
// 获取举报标签配置
export function reportLabel() {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/report/tags',
    method: 'GET',
  });
}

// 提交评价
export function submitEvaluation(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/evaluation',
    method: 'POST',
    data
  });
}

// 获取语音包
export function getVoicePackage(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/voice/config',
    method: 'POST',
    data
  });
}

// 获取图片生成模版
export function getImageTemplates(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/image/tpl_list',
    method: 'POST',
    data
  });
}

// 人像识别接口
export function getImageRecognition(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/image/detect',
    method: 'POST',
    data
  });
}
export function getUriInfo(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/aitalk/uri/info',
    method: 'POST',
    data
  });
}
